var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommentsModule } from '@synisys/idm-comment-control';
import { DeControlsModule, DeSerializationService, } from '@synisys/idm-de-service-client-js';
import { DocumentAuthProviderService } from '@synisys/idm-document-service-client-js';
import { DynamicFormControlsModule } from '@synisys/idm-dynamic-forms-controls';
import { SisUtilitiesModule } from '@synisys/idm-frontend-shared';
import { MessageService } from '@synisys/idm-message-language-service-client-js';
import { ControlsModule, ControlsTranslationService, } from '@synisys/idm-ng-controls';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { DynamicFormComponent, DynamicSubFormComponent, DynamicTemplateModule, GotoDataEntryComponent, WorkflowFormComponent, PopupEntityComponent, PopupSubFormComponent, } from './component';
import { DeContainerComponent } from './de.container.component';
import { DynamicLayoutModule } from './dynamic-layout.module';
import { MaterialModule } from './material.module';
import { WorkflowModule } from '@synisys/idm-workflow-service-client-js';
import { RoutingHistoryService } from './service/local/routing-history.service';
import { MetaFormHelperService } from './service/local/meta-form-helper.service';
import { DeDocumentTokenProvider } from './service/impl/de-document-token-provider.service';
import { DynamicFormClassifiersService, DynamicFormMainDeService } from './service';
import { DYNAMIC_ACTION_CONTAINERS } from '@synisys/idm-dynamic-controls-metadata';
export function controlsTranslationServiceFactory(messageService) {
    return new ControlsTranslationService(messageService);
}
var ɵ0 = [DynamicFormMainDeService], ɵ1 = [DynamicFormClassifiersService, DynamicFormMainDeService];
var DynamicFormModule = /** @class */ (function () {
    function DynamicFormModule() {
    }
    DynamicFormModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                ControlsModule,
                DynamicFormControlsModule,
                DynamicLayoutModule,
                FlashMessagesModule.forRoot(),
                MaterialModule,
                DeControlsModule,
                SisUtilitiesModule,
                DynamicTemplateModule,
                WorkflowModule,
                CommentsModule,
            ],
            declarations: [
                DynamicFormComponent,
                DeContainerComponent,
                DynamicSubFormComponent,
                PopupSubFormComponent,
                GotoDataEntryComponent,
                PopupEntityComponent,
                WorkflowFormComponent,
            ],
            entryComponents: [PopupSubFormComponent],
            exports: [
                DynamicFormComponent,
                DeContainerComponent,
                GotoDataEntryComponent,
                DynamicSubFormComponent,
                PopupEntityComponent,
                WorkflowFormComponent,
            ],
            providers: [
                DeSerializationService,
                RoutingHistoryService,
                MetaFormHelperService,
                { provide: DYNAMIC_ACTION_CONTAINERS, useValue: ɵ0, multi: true },
                { provide: DYNAMIC_ACTION_CONTAINERS, useValue: ɵ1,
                    multi: true
                },
                {
                    provide: DocumentAuthProviderService,
                    useClass: DeDocumentTokenProvider,
                },
                {
                    provide: ControlsTranslationService,
                    useFactory: controlsTranslationServiceFactory,
                    deps: [MessageService],
                },
            ],
        })
    ], DynamicFormModule);
    return DynamicFormModule;
}());
export { DynamicFormModule };
export { ɵ0, ɵ1 };
//# sourceMappingURL=app.module.js.map